import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from 'react-daisyui';
import PaymentModal from 'components/Billing/PaymentModal';
import List from 'components/Billing/List'

const Billing = () => {
  const [showAddPayment, setShowAddPayment] = useState(false);

  return (
    <>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-secondary-900">Billing</h1>
            <p className="text-sm text-secondary-500 mt-0.5">Your balance and payment activity.</p>
          </div>
          <Button
            size="sm"
            className="bg-secondary-900 text-white rounded-xl border-none gap-1.5 hover:bg-secondary-800"
            onClick={() => setShowAddPayment(true)}
          >
            <Plus size={15} />
            Add Payment
          </Button>
        </div>

        <List />
      </div>

      <PaymentModal
        open={showAddPayment}
        onClose={() => setShowAddPayment(false)}
      />
    </>
  );
};

export default Billing;
